module.exports = __webpack_public_path__ + "img/b2-1.debc020.png";